import React from 'react'
import { useTheme } from '@emotion/react'
import * as Styled from './Image/Image.styles'

const Image = ({
  aspectRatio = null,
  borderRadius = null,
  customPosition = null,
  data = null,
  hasMarginBottom = false,
  isImageCritical = false,
  alt = '',
  isSvg,
  inHero, // not used, but we don't want it getting passed to the image through ...props
  spanish, // not used, but we don't want it getting passed to the image through ...props
  srcFallback,
  ...props
}) => {
  if (!data || data?.images?.sources?.length === 0) return null

  if (typeof data === 'string') {
    return <img src={data} alt={alt} style={{ borderRadius }} />
  }

  const { context } = data

  const { spacing } = useTheme() //eslint-disable-line

  // TODO: All this logic should be handled once we know that this LCP claim is still true
  /*
   * Transitioning to full resolution should not occur when image
   * is in the hero section, as it slows down Largest Contentful Paint (LCP)
   */
  // let shouldFadeIn = !isImageCritical
  // let width

  // } else if (fluid) {
  //   width = `${fluid.presentationWidth}px`
  //   // set to true for tracedSVGs, since Lighthouse keeps the SVG as LCP
  //   shouldFadeIn = Boolean(fluid.tracedSVG)
  // } else if (fixed) {
  //   width = `${fixed.presentationWidth}px`
  //   // set to true for tracedSVGs, since Lighthouse keeps the SVG as LCP
  //   shouldFadeIn = Boolean(fixed.tracedSVG)
  // }
  return (
    <Styled.Img
      className={isSvg ? 'sylex-svg' : ''} // Add sylex-svg to both the gatsby wrapper + the actual image
      imgClassName={isSvg ? 'sylex-svg' : ''}
      loading={isImageCritical ? 'eager' : 'lazy'}
      fetchpriority={isImageCritical ? 'high' : 'low'}
      // fadeIn={shouldFadeIn}
      image={data}
      style={{
        marginBottom: hasMarginBottom && `${spacing.md}`,
      }}
      src={srcFallback}
      alt={alt || (context?.custom ? context?.custom?.alt : '')}
      // maxWidth={width}
      position={customPosition || 'initial'}
      ratio={aspectRatio || 'initial'}
      radius={borderRadius || 'initial'}
      {...props}
    />
  )
}

export default Image
